import { Component, Inject, InjectionToken, Injector, OnDestroy, ViewEncapsulation } from '@angular/core';
import { IOperationOverlayLargeDialogData } from '../operation-overlay-large.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isDefined } from '@fi-shared/utils/is-defined';
import { Subject, Subscription } from 'rxjs';
import { ListDataService } from '@fi-app/components/items-list/list-data.service';
import { FiItemsListHelperService } from '@fi-shared/fi-items-list/fi-items-list-helper.service';
import { takeUntil } from 'rxjs/operators';

export const OPERATION_OVERLAY_LARGE_CONTENT_DATA = new InjectionToken<any>('OperationOverlayLargeContentData');
export const OPERATION_OVERLAY_LARGE_DIALOG_REF = new InjectionToken<any>('OperationOverlayLargeDialogRef');

@Component({
    selector: 'fi-operation-overlay-large-dialog',
    templateUrl: './operation-overlay-large-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./operation-overlay-large-dialog.component.scss'],
    standalone: false,
})
export class OperationOverlayLargeDialogComponent implements OnDestroy {
    params: IOperationOverlayLargeDialogData;

    contentComponent;
    contentInjector: Injector;

    SelectedListItem = null;
    SelectedItemsList = [];

    private CcmListItemSelectedChange: Subscription;

    constructor(
        @Inject(MAT_DIALOG_DATA) dialogData: IOperationOverlayLargeDialogData,
        private dialogRef: MatDialogRef<OperationOverlayLargeDialogComponent>,
        injector: Injector,
    ) {
        this.params = Object.assign({ IsEditWindow: false, IsSelectWindow: false }, dialogData);
        this.SelectedListItem = this.params.SelectedListItem;

        const contentData = Object.assign(dialogData.contentData.data, { filterPrams: this.params.filterPrams });

        this.contentComponent = dialogData.contentData.component;
        this.contentInjector = Injector.create({
            providers: [
                { provide: OPERATION_OVERLAY_LARGE_CONTENT_DATA, useValue: contentData },
                { provide: OPERATION_OVERLAY_LARGE_DIALOG_REF, useValue: this.dialogRef },
            ],
            parent: injector,
        });

        const listDataService = injector.get(ListDataService);

        this.CcmListItemSelectedChange = listDataService.onListItemSelectedChange((selectedItems) => {
            // todo this part should be removed after migrating all lists to material tables
            if (this.params.multiple == true) {
                this.SelectedItemsList = selectedItems;
            }

            this.SelectedListItem = selectedItems[0];
        });

        // material lists support
        const itemsListHelperService = injector.get(FiItemsListHelperService);
        itemsListHelperService.extendedSearchSelectionChanged$
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((selectedItems) => {
                if (this.params.multiple == true) {
                    this.SelectedItemsList = selectedItems;
                }
                this.SelectedListItem = selectedItems[0];
            });
    }

    CloseClick($event) {
        $event.stopPropagation();
        this.dialogRef.close();
    }

    closeWithResult() {
        if (isDefined(this.params.resultValue)) {
            this.dialogRef.close(this.params.resultValue);
        }

        if (this.params.multiple == true) {
            this.dialogRef.close(this.SelectedItemsList);
        } else {
            this.dialogRef.close(this.SelectedListItem);
        }
    }

    InsertClick($event) {
        $event.stopPropagation();
        this.closeWithResult();
    }

    SelectClick() {
        this.closeWithResult();
    }

    IsInsertDisabled() {
        return !this.SelectedListItem && (this.params.multiple == false || this.SelectedItemsList.length == 0);
    }

    isShowInsert() {
        return !this.params.IsSelectWindow && !(this.params.showInsert === false);
    }

    isShowSave() {
        return this.params.showSave === true;
    }

    saveClick() {
        this.params.onSaveClick();
    }

    isShowNew() {
        return this.params.showBtnNew === true;
    }

    newClick() {
        this.params.newClick();
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
        this.CcmListItemSelectedChange.unsubscribe();
    }
}
